"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "CustomIcon__Wrapper",
  componentId: "design-system__sc-1dzmfnx-0"
})(["line-height:normal;max-width:", ";max-height:", ";cursor:", ";& > img{border-radius:0.25rem;}"], _ref => {
  let {
    size
  } = _ref;
  return "".concat(size, "px");
}, _ref2 => {
  let {
    size
  } = _ref2;
  return "".concat(size, "px");
}, _ref3 => {
  let {
    onClick
  } = _ref3;
  return onClick ? 'pointer' : 'default';
});

const CustomIcon = _ref4 => {
  let {
    imgSrc,
    size,
    onClick,
    title,
    alt
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-testid": "component-wrapper",
    size: size,
    onClick: onClick
  }, imgSrc ? /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "component-image",
    src: imgSrc,
    alt: alt,
    title: title,
    width: size,
    height: size
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "appicon",
    size: size,
    title: title
  }));
};

CustomIcon.propTypes = {
  size: _propTypes.default.string,
  imgSrc: _propTypes.default.string,
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  alt: _propTypes.default.string
};
CustomIcon.defaultProps = {
  size: '50',
  imgSrc: undefined,
  onClick: undefined,
  title: undefined,
  alt: undefined
};
var _default = CustomIcon;
exports.default = _default;